import { dialog } from "../../../../../nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../../usecases/object";
import DialogModal from "../../../../../components/Dialog";

class WasteComponentFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async deductComponents({ storeId, componentSku, wasteQty }) {
    if (!storeId || !componentSku || !wasteQty) return;
    console.log("WQWWW", componentSku, storeId);
    // A) Find product (same sku + storeId)
    const components = await findObjectUseCase().execute("components", {
      where: {
        sku: String(componentSku),
        // storeId: { id: storeId },
      },
      limit: 1,
      keys: ["id", "sku", "itemName", "quantity", "cost"],
    });

    console.log("pp", components);

    const component = Array.isArray(components) ? components[0] : null;

    console.log("component", component);

    const componentQty = component.quantity;
    const deductQty = componentQty;
    // * Number(wasteQty);
    console.log("wasteQty", wasteQty);
    console.log("componentQty", componentQty);
    console.log("deductQty", deductQty);

    // Find inventory row
    const pofbu = await findObjectUseCase().execute("inventory", {
      where: {
        sku: component?.sku,
        storeId: { id: storeId },
      },
      include: ["component"],
      keys: [
        "id",
        "sku",
        "component",
        "storeId",
        "quantity",
        "systemCount",
        "itemName",
      ],
    });

    console.log("pofbu", pofbu);

    const pofbuObj = Array.isArray(pofbu) ? pofbu[0] : null;
    console.log("pofbuObj", pofbuObj);

    // const current = Number(pofbuObj.quantity ?? 0);
    const current = Number(pofbuObj.systemCount ?? 0);
    const nextQuantity = current - wasteQty;

    console.log("Update INV:", {
      id: pofbuObj.id,
      systemCount: nextQuantity,
    });

    // Update pofb row
    await this.upsertUseCase.execute("inventory", {
      id: pofbuObj.id,
      systemCount: String(nextQuantity),
    });

    // // Find inventory row
    // const pofbu = await findObjectUseCase().execute("backup_pullouts", {
    //   where: {
    //     component: { sku: component?.sku },
    //     storeId: { id: storeId },
    //   },
    //   include: ["component"],
    //   keys: ["id", "sku", "component", "storeId", "quantity"],
    // });

    // console.log("pofbu", pofbu);

    // const pofbuObj = Array.isArray(pofbu) ? pofbu[0] : null;
    // console.log("pofbuObj", pofbuObj);

    // const current = Number(pofbuObj.quantity ?? 0);
    // const nextQuantity = current - wasteQty;

    // console.log("Update INV:", {
    //   id: pofbuObj.id,
    //   quantity: nextQuantity,
    // });

    // // Update pofb row
    // await this.upsertUseCase.execute("backup_pullouts", {
    //   id: pofbuObj.id,
    //   quantity: String(nextQuantity),
    // });
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const storeId = user?.storeAnalytic?.[0]?.id;

    const base = {};
    if (this.object?.id) {
      base.id = this.object.id;
    } else {
      base.acl = this.view.getAcl();
      base.storeId = { id: storeId };
      base.category = "components";
    }

    const items = this.change?.items || this.object?.items || [];

    // 1) Build one payload per item (breakdown)
    const payloads = (Array.isArray(items) ? items : []).map((it) => ({
      ...base,
      product: it.product || null,
      name: it.itemName || it.name || "",
      sku: it.sku || "",
      amount: String(it.cost ?? it.amount ?? 0),
      quantity: String(it.quantity ?? 0),
      description: it.description || "",
      wasteType: "Manual Waste" || "POS Waste",
      voidDate: new Date().toISOString(),
      isUpsale: false,
    }));

    console.log("Payloads Post (breakdown): ", payloads);

    try {
      // 2) Save each waste record
      for (const payload of payloads) {
        console.log("Pay", payload);
        delete payload.product;
        await this.upsertUseCase.execute(collection, payload);

        // 3) After  save: deduct raw materials for this waste line
        await this.deductComponents({
          storeId,
          componentSku: payload.sku,
          wasteQty: payload.quantity,
        });
      }

      this.change = {};
      this.view.hideProgressDialog();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              dialog.close();
              this.view.navigateBack();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();
      // this.view.submissionSuccess();
      // this.view.showSuccessSnackbar("Successfully saved!");
      // this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default WasteComponentFormPresenter;
